<template>
  <div
    class="search-panel"
    :class="bem('search-panel', { appearance })"
  >
    <div
      v-if="!$slots.primary && !$slots.secondary ? mediaQueries.mobile : true"
      class="search-panel__wrapper"
      :class="bem('search-panel__wrapper', { appearance })"
    >
      <InputGroup v-if="mediaQueries.mobile" direction="vertical" gap="small">
        <BasicColumns
          :appearance="$slots.secondary ? 'filters-with-order' : null"
          :responsive="false"
        >
          <BasicButton
            size="l"
            appearance="filters"
            @click="$emit('openFilters')"
          >
            <WithIndicator
              :visible="indicatorVisible"
              :appearance="indicatorAppearance"
            >
              Фильтры
            </WithIndicator>
          </BasicButton>
          <slot name="secondary" />
        </BasicColumns>
        <slot name="primary" />
      </InputGroup>

      <BasicColumns
        v-else
        appearance="search-with-order"
      >
        <slot name="primary" />
        <slot name="secondary" />
      </BasicColumns>
    </div>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';
  import { createPropModel, modelValueConfig } from 'src/utils/vue.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicColumns from 'src/components/BasicColumns/BasicColumns.vue';
  import InputGroup from 'src/components/form/InputGroup/InputGroup.vue';
  import WithIndicator from 'src/components/WithIndicator/WithIndicator.vue';

  export default {
    name: 'SearchPanel',
    components: {
      WithIndicator,
      BasicButton,
      BasicColumns,
      InputGroup,
    },
    model: modelValueConfig(),
    inject: ['mediaQueries'],
    props: {
      modelValue: String,
      indicatorVisible: Boolean,
      indicatorAppearance: String,
      appearance: {
        type: String,
        default: null,
        validator: v => ['new-search-panel'].includes(v),
      },
    },
    methods: {
      bem,
    },
    computed: {
      model: createPropModel('modelValue')
    }
  }
</script>